import { getPromiseWithResolvers } from "./getPromiseWithResolvers";

const timeoutMap: Map<string, number> = new Map();

export async function debounce(func: () => unknown, timeout = 250, id?: string) {
    const { promise, resolve } = getPromiseWithResolvers();
    
    if (!id) {
        const encoded = new TextEncoder().encode(func.toString())
        const hashBuffer = await crypto.subtle.digest('SHA-256', encoded);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
        id = hashHex;
    }

    const foundTimeoutId = timeoutMap.get(id);
    if (foundTimeoutId) {
        clearTimeout(foundTimeoutId);
        timeoutMap.delete(id);
    } 

    const timeoutId = setTimeout(async () => resolve(await func()), timeout);
    timeoutMap.set(id, timeoutId);

    await promise;
}